  document.addEventListener("DOMContentLoaded", function () {
    const swiperEl = document.querySelector('.shop-type-swiper');
    if (swiperEl) {
      const section = swiperEl.closest('.shop-by-type-section');
      const prevEl = section ? section.querySelector('.swiper-button-prev') : null;
      const nextEl = section ? section.querySelector('.swiper-button-next') : null;

      new Swiper(swiperEl, {
        slidesPerView: 1.33,
        spaceBetween: 15,
        grabCursor: true,
        navigation: {
          prevEl,
          nextEl
        },
        breakpoints: {
          768: {
            slidesPerView: 5,
            spaceBetween: 15
          }
        }
      });
    }
  });
